import React, { useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackIcon from "@material-ui/icons/KeyboardBackspaceOutlined";
import dayjs from "dayjs";
import FloatIcons from "../mini/FloatIcons";
import { Avatar } from "antd";
import CommentBox from "../mini/CommentBox";
import MiniArticle from "../mini/MiniArticle";
import getOneImageFromSections from "../../utils/getFeturedImageForPosts";
import CustomLink from "../mini/Link";
import ConfirmModal from "../mega/ConfirmModal";
import Comment from "../mega/Comment";
import { useAuthStore } from "../../store/AuthStore";
import Power from "../../shared/Power/Power";

const URL_REGEX =
  /http(s?):\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)/;

const ViewPostDesktop = ({
  title,
  post,
  searchByTag,
  postData,
  postImage,
  following,
  primaryBtnAction,
  setComCount,
  comCount,
  commentCount,
  comments,
  moreFrom,
  related,
  getComments,
}) => {
  const history = useHistory();
  const { state } = useLocation();

  const ref = useRef(null);
  const { userData, isLoggedIn, blogData } = useAuthStore();

  const convertLinks = (txt) =>
    txt.split(" ").map((part) =>
      URL_REGEX.test(part) ? (
        <a
          className="text-primary"
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}{" "}
        </a>
      ) : (
        part + " "
      )
    );

  const handleGoToComment = () => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="web-container">
      <div className="header-root">
        <div className="max-w-screen-xl mx-auto header">
          <div>
            <p
              className="back"
              onClick={() => {
                if (state) {
                  history.replace({
                    pathname: state.pathname,
                    state: { stateForwarding: state },
                  });
                }
                history.goBack();
              }}
            >
              <BackIcon /> BACK
            </p>
          </div>
          <div className="title">
            <h1>{title}</h1>
            {isLoggedIn && post.blog.author.id === userData.id && (
              <div className="buttons">
                <div
                  className="post-button"
                  onClick={() =>
                    history.push({
                      pathname: `/createPost/${post.blogId}/post/${post.id}`,
                      state: { isEdit: true },
                    })
                  }
                >
                  Edit Post
                </div>

                <div
                  className="post-button"
                  onClick={() =>
                    history.push(`/dashboard/${blogData.urlSlug}/my_posts`)
                  }
                >
                  My Posts
                </div>
              </div>
            )}
          </div>

          <div className="tags">
            {post?.tags?.map((tag) => (
              <div
                key={tag.id}
                className="custom-tag"
                onClick={(e) => searchByTag(e, tag.name.toLowerCase())}
              >
                #{tag.name}
              </div>
            ))}
          </div>

          <div className="author">
            <Avatar src={post?.blog?.author?.profileImage}>
              {post?.blog?.author?.firstName[0]}
              {post?.blog?.author?.lastName[0] ?? ""}
            </Avatar>

            <div className="author-info">
              <p>
                by{" "}
                <span
                  onClick={() =>
                    history.push(`/blogfolio/${post?.blog?.urlSlug}/about`)
                  }
                >
                  Dr. {post?.blog?.author?.firstName}{" "}
                  {post?.blog?.author?.lastName ?? ""}
                </span>{" "}
                in{" "}
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    history.push(`/blogfolio/${post?.blog?.urlSlug}/posts`)
                  }
                >
                  {post?.blog?.title}
                </span>
              </p>
              <p>{dayjs(post?.updatedAt).format("DD MMM YYYY")} (edited)</p>
            </div>
          </div>

          <div className="bar">
            <Power count={post?.powerScore} isViewPost={true} />
            <FloatIcons post={post} handleGoToComment={handleGoToComment} />
          </div>
        </div>
      </div>

      <div
        className="max-w-screen-xl mx-auto flex"
        style={{ padding: "0 30px" }}
      >
        <div className="w-2/3 relative pstContent">
          {/* Post Image */}
          {post?.imageUrl && (
            <div className="viewpostImageWrapper">
              <div className="imgWrapper">
                <img src={post?.imageUrl} alt={postImage.alt} />
              </div>
              <div className="captionWrapper">
                <p className="caption">{postImage.alt}</p>
              </div>
            </div>
          )}

          {/* Post Data */}
          <div
            className="viewpostDataWrapper"
            dangerouslySetInnerHTML={{ __html: postData }}
          />

          {post?.blog?.author && (
            <div className="author-view-container mb-4">
              <div
                className="mob-block flex mb-3"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  className="flex"
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="d-flex">
                    <Avatar
                      className="mr-3"
                      size={80}
                      src={post?.blog?.author?.profileImage}
                    >
                      {post?.blog?.author?.firstName
                        ? post?.blog?.author?.firstName[0]
                        : ""}
                      {post?.blog?.author?.lastName
                        ? post?.blog?.author?.lastName[0]
                        : ""}
                    </Avatar>
                    <div>
                      <p style={{ fontSize: "14px" }}>About the Author</p>
                      <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Dr.{" "}
                        {`${post?.blog?.author?.firstName} ${
                          post?.blog?.author?.lastName
                            ? post?.blog?.author?.lastName
                            : ""
                        }`}
                      </p>
                    </div>
                  </div>
                  <div style={{ marginLeft: "25px" }}>
                    <div
                      className="mob-block flex justify-end items-end"
                      style={{ float: "right" }}
                    >
                      <button
                        onClick={() => {
                          history.push(
                            `/blogfolio/${post?.blog?.urlSlug}/about`
                          );
                        }}
                        style={{ lineHeight: 1.3 }}
                        className={`font-bold rounded-full text-sm btn-custom-sm bg-700-border white-button-bg-700-border }`}
                      >
                        VIEW BLOG
                      </button>
                      {isLoggedIn &&
                        userData.id !== post.blog?.author?.id &&
                        (following ? (
                          <button
                            style={{ lineHeight: 1.3 }}
                            className={`ml-4 font-bold rounded-full text-sm btn-custom-sm bg-700-border bg-blue-700 text-white`}
                          >
                            <ConfirmModal
                              title="Are you sure you want to unfollow?"
                              btnName="UNFOLLOW BLOG"
                              onOk={() => {
                                primaryBtnAction();
                              }}
                            />
                          </button>
                        ) : (
                          <button
                            onClick={primaryBtnAction}
                            style={{ lineHeight: 1.3 }}
                            className={`ml-4 font-bold rounded-full text-sm btn-custom-sm bg-700-border bg-blue-700 text-white`}
                          >
                            FOLLOW BLOG
                          </button>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-4">
                {post?.blog?.description &&
                  convertLinks(post?.blog?.description)}
              </div>
            </div>
          )}
          <h1 className="comment-head" ref={ref}>
            {commentCount} Comments
          </h1>
          {isLoggedIn && (
            <CommentBox
              callChild={() => setComCount(comCount + 2)}
              postId={post?.id}
              refetch={getComments}
            />
          )}
          {comments?.map((comment) => (
            <div key={comment.id}>
              <Comment
                callSelf={() => setComCount(comCount + 2)}
                comment={comment}
              />
              <hr className="line my-8" />
            </div>
          ))}
          {commentCount > comments?.length && (
            <p onClick={() => setComCount(comCount + 2)} className="load">
              LOAD MORE COMMENTS
            </p>
          )}
        </div>

        <div className="w-1/3 pl-8">
          {post?.blog && moreFrom?.length > 0 && (
            <>
              <h2 className="mb-4">More From {post?.blog?.title}</h2>
              <div className="flex flex-col gap-4" style={{ width: "100%" }}>
                {moreFrom.map((post) => (
                  <MiniArticle
                    key={post?.id}
                    history={history}
                    slug={post?.urlSlug}
                    title={post?.title}
                    imageUrl={
                      post?.imageUrl || getOneImageFromSections(post?.sections)
                    }
                  />
                ))}
              </div>
              <div className="text-right">
                <CustomLink
                  to={`/blogfolio/${post?.blog?.urlSlug}/posts`}
                  type="viewAll"
                >
                  VIEW ALL
                </CustomLink>
              </div>
            </>
          )}
          {related && !!related?.length && (
            <>
              <h2 className="mt-24 mb-4">Related Articles</h2>
              <div className="flex flex-col gap-4">
                {related?.map((post) => (
                  <MiniArticle
                    key={post?.id}
                    history={history}
                    slug={post?.urlSlug}
                    title={post?.title}
                    imageUrl={
                      post?.imageUrl || getOneImageFromSections(post?.sections)
                    }
                  />
                ))}
                <div className="text-right">
                  {post?.tags?.length > 0 && (
                    <CustomLink
                      to={`/search/1/posts/tags=${encodeURIComponent(
                        post?.tags[0].name
                      )}`}
                      type="viewAll"
                    >
                      {" "}
                      VIEW ALL{" "}
                    </CustomLink>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewPostDesktop;
